
import moment from 'moment';
import React from 'react';
import { Modal, Button, Accordion, Table, Badge } from 'react-bootstrap';

const InsuranceClaimModal = ({ show, onClose, data }) => {
    console.log(data)
  

  return (
    <Modal show={show} onHide={onClose} centered size="">
      <Modal.Header closeButton>
        <Modal.Title>Insurance Claim</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Appointment Details */}
        <div className={"divider divider-start fw-medium"}>
            <span>Insurance Claim Details</span>
        </div>
        <div className='d-flex align-items-cente gap-2'>
            <strong>Date:</strong>
            <div className="mb-0 d-flex gap-2 align-items-cente">
                <label className="d-block text-primary fs-sm mb-1">{moment(data?.createdAt).format("D MMM, YYYY")}</label>
                <h6>{moment(data?.createdAt).format("dddd, h:mm A")}</h6>
            </div>
        </div>
        <p className='mb-2'><strong>Service:</strong> {data?.description ?? "---"}</p>
        <p className='mb-2'><strong>Scheme:</strong> {data?.scheme?.name ?? "---"} <span className='text-danger'>({data?.scheme?.hmoType?.name ?? "---"})</span></p>
        <p className='mb-2'><strong>Bil Source:</strong><span className='text-primary'> {data?.bill_source ?? "---"}</span></p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InsuranceClaimModal;
